import { AbstractControl } from '@angular/forms';
// This is temporary fix until we upgrade Angular
declare module '@angular/forms' {
  interface AbstractControl {
    isRequired(): boolean;
  }
}

AbstractControl.prototype.isRequired = function isRequired(
  this: AbstractControl
) {
  if (this.validator) {
    return this.validator({} as any)?.required;
  }
};
